const root = '/trusted';

export default {
  root,
} as const;
